import React, { Component } from "react";
import ShareWith from "../CreateNewFolder/ShareWith/ShareWith";
import { apolloClient } from "../..";
import { gql } from "@apollo/client";
import dateFormat from "dateformat";
import CloseIcon from "../../assets/icons/close.svg";
import { notify } from "../Notify/Notify";
import { getIntials } from "../../helper";
import { Modal } from "react-bootstrap";

class ShareModal extends Component {
  state = {
    accessUsers: [],
    filteredUsers: [],
    defaultUser: {},
    folderAccess: [],
    defaultRole: "",
    filterSubFolders: [],
    filterDocuments: [],
  };

  getTotalDays = (date) => {
    const dateDay = dateFormat(date, "dd");
    const dateMonth = dateFormat(date, "mm");
    const dateYear = dateFormat(date, "yyyy");

    let first = new Date();
    let second = new Date(
      parseInt(dateYear),
      parseInt(dateMonth) - 1,
      parseInt(dateDay)
    );

    const totalDays = Math.round((second - first) / (1000 * 60 * 60 * 24));
    return totalDays;
  };

  setAccessUsers = (usersArr) => {
    Object.entries(this.state.defaultUser).length === 0 &&
      this.setState({ defaultUser: usersArr[0] });

    const filteredArr = usersArr.reduce((acc, current) => {
      const x = acc.find((item) => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    this.setState({ accessUsers: filteredArr });
  };

  setFilteredUsers = (filterUsers) => {
    this.setState({ filteredUsers: filterUsers });
  };

  getSharedUsers = () => {
    const GET_SHARED_USERS =
      this.props.shareFolder.__typename === "DocumentType"
        ? `query DocumentSharedWith($documentId: UUID!) {
      documentSharedWith(documentId: $documentId){
        document{
          title
        }
        user{
          id
          username
          firstName
          lastName
          username
          profile{
            image
          }
        }
        userRole{
          id
          name
        }
        expiredTs
      }
    }`
        : `
    query FolderSharedWith($folderId: UUID!) {
      folderSharedWith(folderId: $folderId) {
        user {
          id
          username
          firstName
          lastName
          username
          profile{
            image
          }
        }
        userRole {
          id
          name
        }
        expiredTs
      }
    }
  `;
    const variables =
      this.props.shareFolder.__typename === "DocumentType"
        ? {
            documentId: this.props.shareFolder.id,
          }
        : {
            folderId: this.props.shareFolder.id,
          };
    apolloClient
      .query({
        query: gql`
          ${GET_SHARED_USERS}
        `,
        variables: variables,
      })
      .then((result) => {
        let shareUsers = [];
        let defaultRole = "";
        const res =
          this.props.shareFolder.__typename === "DocumentType"
            ? result.data.documentSharedWith
            : result.data.folderSharedWith;
        const accessUserIds = this.state.accessUsers.map(
          (accessUser) => accessUser.id
        );

        res.map((folderShare) => {
          const checkContains =
            folderShare.user.id === this.props.currentUserInfo.id &&
            accessUserIds.includes(folderShare.user.id);
          checkContains && (defaultRole = folderShare.userRole.name);
          return shareUsers.push({
            id: folderShare.user.id,
            username: folderShare.user.username,
            firstName: folderShare.user.firstName,
            lastName: folderShare.user.lastName,
            image: folderShare.user.profile.image,
            intials: getIntials(folderShare.user),
            name: folderShare.user.firstName + " " + folderShare.user.lastName,
            access: folderShare.userRole.name,
            temporaryDate: folderShare.expiredTs
              ? dateFormat(folderShare.expiredTs, "mmm dd, yyyy")
              : "",
            datePicker: false,
            disable: checkContains ? true : false,
            arrowDown: true,
          });
        });

        // get login user--->
        let loginUser = {};
        if (
          parseInt(this.props.currentUserInfo.profile.role.id) === 1 ||
          parseInt(this.props.currentUserInfo.profile.role.id) === 2
        ) {
          loginUser = this.state.accessUsers.find(
            (accessUser) => accessUser.id === this.props.currentUserInfo.id
          );
        } else {
          const disableUsers = this.state.accessUsers.map(
            (user) => user.disable
          );
          if (disableUsers.length === 1) {
            loginUser = this.state.accessUsers.find(
              (accessUser) => accessUser.id === this.props.currentUserInfo.id
            );
          } else {
            loginUser = shareUsers.find(
              (accessUser) => accessUser.id === this.props.currentUserInfo.id
            );
          }
        }
        const folderAccess =
          loginUser && loginUser.access === "Owner"
            ? [
                { id: 31, access: "Owner" },
                { id: 32, access: "Collaborator" },
                { id: 33, access: "Viewer" },
                { id: 34, access: "Temporary User" },
              ]
            : [
                { id: 32, access: "Collaborator" },
                { id: 33, access: "Viewer" },
                { id: 34, access: "Temporary User" },
              ];
        this.setState({
          defaultRole: defaultRole,
          accessUsers: [this.state.defaultUser, ...shareUsers],
          folderAccess: folderAccess,
        });
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  multipleShare = (currentUser) => {
    if (
      parseInt(currentUser.profile.role.id) === 1 ||
      parseInt(currentUser.profile.role.id) === 2
    ) {
      const folderAccess = [
        { id: 31, access: "Owner" },
        { id: 32, access: "Collaborator" },
        { id: 33, access: "Viewer" },
        { id: 34, access: "Temporary User" },
      ];
      if (this.props.shareFolder.__typename === "DocumentType") {
        let documents = this.props.documents;
        documents = documents.filter(
          (doc) => this.props.checkedShareFolder[doc.id]
        );
        this.setState({
          defaultRole: "Owner",
          folderAccess: folderAccess,
          accessUsers: [],
          filterDocuments: documents,
        });
      } else {
        let subFolders =
          this.props.subFolders[this.props.match.params.folderId];
        subFolders = subFolders.filter(
          (subFolder) => this.props.checkedShareFolder[subFolder.id]
        );
        this.setState({
          defaultRole: "Owner",
          folderAccess: folderAccess,
          accessUsers: [],
          filterSubFolders: subFolders,
        });
      }
    } else {
      if (this.props.shareFolder.__typename === "DocumentType") {
        let documents = [...this.props.documents];
        documents = documents.filter(
          (document) => this.props.checkedShareFolder[document.id]
        );
        let type;
        documents.filter((doc) => {
          const getLoginUser = doc.sharedDocument.filter(
            (user) => user.user.id === currentUser.id
          );
          return (
            getLoginUser.filter((user) => user.userRole.name === "Owner")
              .length === getLoginUser.length
          );
        }).length === documents.length
          ? (type = "Owner")
          : documents.filter((doc) => {
              const getLoginUser = doc.sharedDocument.filter(
                (user) => user.user.id === currentUser.id
              );
              return (
                getLoginUser.filter(
                  (user) =>
                    user.userRole.name === "Owner" ||
                    user.userRole.name === "Collaborator"
                ).length === getLoginUser.length
              );
            }).length === documents.length
          ? (type = "Collaborator")
          : (type = "");

        if (type === "Collaborator") {
          const folderAccess = [
            { id: 32, access: "Collaborator" },
            { id: 33, access: "Viewer" },
            { id: 34, access: "Temporary User" },
          ];
          this.setState({
            defaultRole: "Collaborator",
            folderAccess: folderAccess,
            accessUsers: [],
            filterDocuments: documents,
          });
        } else if (type === "Owner") {
          const folderAccess = [
            { id: 31, access: "Owner" },
            { id: 32, access: "Collaborator" },
            { id: 33, access: "Viewer" },
            { id: 34, access: "Temporary User" },
          ];
          this.setState({
            defaultRole: "Owner",
            folderAccess: folderAccess,
            accessUsers: [],
            filterDocuments: documents,
          });
        }
      } else {
        let subFolders =
          this.props.subFolders[this.props.match.params.folderId];
        subFolders = subFolders.filter(
          (subFolder) => this.props.checkedShareFolder[subFolder.id]
        );
        let type;
        subFolders.filter((sub) => {
          const getLoginUser = sub.sharedFolder.filter(
            (user) => user.user.id === currentUser.id
          );
          return (
            getLoginUser.filter((user) => user.userRole.name === "Owner")
              .length === getLoginUser.length
          );
        }).length === subFolders.length
          ? (type = "Owner")
          : subFolders.filter((sub) => {
              const getLoginUser = sub.sharedFolder.filter(
                (user) => user.user.id === currentUser.id
              );
              return (
                getLoginUser.filter(
                  (user) =>
                    user.userRole.name === "Owner" ||
                    user.userRole.name === "Collaborator"
                ).length === getLoginUser.length
              );
            }).length === subFolders.length
          ? (type = "Collaborator")
          : (type = "");

        if (type === "Collaborator") {
          const folderAccess = [
            { id: 32, access: "Collaborator" },
            { id: 33, access: "Viewer" },
            { id: 34, access: "Temporary User" },
          ];
          this.setState({
            defaultRole: "Collaborator",
            folderAccess: folderAccess,
            accessUsers: [],
            filterSubFolders: subFolders,
          });
        } else if (type === "Owner") {
          const folderAccess = [
            { id: 31, access: "Owner" },
            { id: 32, access: "Collaborator" },
            { id: 33, access: "Viewer" },
            { id: 34, access: "Temporary User" },
          ];
          this.setState({
            defaultRole: "Owner",
            folderAccess: folderAccess,
            accessUsers: [],
            filterSubFolders: subFolders,
          });
        }
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.shareFolder) {
      if (this.props.totalCheck === 0 && this.props !== prevProps) {
        Object.keys(this.props.shareFolder).length > 0 && this.getSharedUsers();
      }
    }
  }

  shareHandler = (e) => {
    let flag = false;
    e.preventDefault();
    let SHARE_HANDLER =
      this.props.shareFolder.__typename === "DocumentType"
        ? `mutation ShareDocument($sharedWithJson: String!){
          shareDocument(sharedWithJson: $sharedWithJson) {
            success
          }
        }`
        : `mutation ShareFolder($sharedWithJson: String!) {
      shareFolder(sharedWithJson: $sharedWithJson) {
        success
      }
    }`;
    let userIds_data = [];
    let shareArr = [];
    let variables = [];
    let updatedAccessUsers = [...this.state.accessUsers];
    if (this.props.totalCheck > 0) {
      this.state.accessUsers.map((accessUser, index) => {
        return accessUser.access !== "Temporary User"
          ? userIds_data.push({
              id: parseInt(accessUser.id),
              role: accessUser.access,
            })
          : userIds_data.push({
              id: parseInt(accessUser.id),
              role: "Temporary User",
              days: this.getTotalDays(accessUser.temporaryDate),
            });
      });

      for (const [key, value] of Object.entries(
        this.props.checkedShareFolder
      )) {
        if (value) {
          if (this.props.shareFolder.__typename === "DocumentType" || this.props.shareMultipleDocument) {
            flag = true;
            const findDocument = this.props.documents.find(
              (doc) => doc.id === key
            );
            const sharedDocUsers = findDocument.sharedDocument.filter(
              (user) =>
                user.user.profile.role.name !== "IT Admin" &&
                user.user.profile.role.name !== "Admin"
            );
            const getDocUserIds = userIds_data.map((user) => user.id);
            const updatedDocUserIds = [];
            sharedDocUsers.forEach(
              (user) =>
                !getDocUserIds.includes(parseInt(user.user.id)) &&
                updatedDocUserIds.push({
                  id: parseInt(user.user.id),
                  role: user.userRole.name,
                })
            );
            shareArr.push({
              document_id: key,
              user_ids: [...updatedDocUserIds, ...userIds_data],
            });
          } else {
            const findSubFolder = this.props.subFolders[
              this.props.match.params.folderId
            ].find((sub) => sub.id === key);
            const sharedUsers = findSubFolder.sharedFolder.filter(
              (user) =>
                user.user.profile.role.name !== "IT Admin" &&
                user.user.profile.role.name !== "Admin"
            );
            const getUserIds = userIds_data.map((user) => user.id);
            const updatedUserIds = [];
            sharedUsers.forEach(
              (user) =>
                !getUserIds.includes(parseInt(user.user.id)) &&
                updatedUserIds.push({
                  id: parseInt(user.user.id),
                  role: user.userRole.name,
                })
            );

            shareArr.push({
              folder_id: key,
              user_ids: [...updatedUserIds, ...userIds_data],
            });
          }
        }
      }
      variables = {
        sharedWithJson: JSON.stringify(shareArr),
      };
    } else {
      this.state.accessUsers.map((accessUser, index) => {
        return index !== 0 && accessUser.access !== "Temporary User"
          ? userIds_data.push({
              id: parseInt(accessUser.id),
              role: accessUser.access,
            })
          : accessUser.access === "Temporary User"
          ? userIds_data.push({
              id: parseInt(accessUser.id),
              role: "Temporary User",
              days: this.getTotalDays(accessUser.temporaryDate),
            })
          : null;
      });
      variables =
        this.props.shareFolder.__typename === "DocumentType"
          ? {
              sharedWithJson: JSON.stringify([
                {
                  document_id: this.props.shareFolder.id,
                  user_ids: userIds_data,
                },
              ]),
            }
          : {
              sharedWithJson: JSON.stringify([
                {
                  folder_id: this.props.shareFolder.id,
                  user_ids: userIds_data,
                },
              ]),
            };
    }
    // return;
    if(flag){
      SHARE_HANDLER =
         `mutation ShareDocument($sharedWithJson: String!){
          shareDocument(sharedWithJson: $sharedWithJson) {
            success
          }
        }`
    }
    apolloClient
      .mutate({
        mutation: gql`
          ${SHARE_HANDLER}
        `,
        variables: variables,
      })
      .then((result) => {
        // multiple folders and documnets
        if (this.props.totalCheck > 0) {
          this.props.setShareFolders({}, 0);
          this.setState({
            accessUsers: [],
            filteredUsers: [],
            defaultUser: {},
            defaultRole: "",
          });

          // updatesharedWith---->
          if (this.props.shareFolder.__typename === "DocumentType") {
            const filterDocuments = [...this.state.filterDocuments];
            this.props.documents.forEach((doc) => {
              const findDocument = filterDocuments.find(
                (filterDocument) => filterDocument.id === doc.id
              );
              if (findDocument) {
                let sharedDocArr = [...findDocument.sharedDocument];
                const sharedIds = sharedDocArr
                  .filter(
                    (user) =>
                      user.user.profile.role.name !== "IT Admin" &&
                      user.user.profile.role.name !== "Admin"
                  )
                  .map((user) => user.user.id);
                updatedAccessUsers.forEach((updatedAccessUser) => {
                  if (!sharedIds.includes(updatedAccessUser.id)) {
                    const {
                      id,
                      access,
                      firstName,
                      lastName,
                      username,
                      profile,
                    } = updatedAccessUser;
                    sharedDocArr.push({
                      id: findDocument.id,
                      user: {
                        email: username,
                        id,
                        firstName,
                        lastName,
                        username,
                        profile,
                      },
                      userRole: {
                        id,
                        name: access,
                      },
                    });
                  } else {
                    // update role--->
                    sharedDocArr.forEach((user) => {
                      if (user.user.id === updatedAccessUser.id) {
                        user.userRole.name = updatedAccessUser.access;
                      }
                    });
                  }

                  findDocument.sharedDocument = sharedDocArr;
                });
              }
            });
            this.props.updateDocuments(this.props.documents);
          } else {
            const rootFolders = [...this.props.rootFolders];
            const subFolders = { ...this.props.subFolders };
            const filterSubFolders = [...this.state.filterSubFolders];
            filterSubFolders.forEach((filterSubFolder) => {
              let sharedArr = [...filterSubFolder.sharedFolder];
              const sharedIds = sharedArr
                .filter(
                  (user) =>
                    user.user.profile.role.name !== "IT Admin" &&
                    user.user.profile.role.name !== "Admin"
                )
                .map((user) => user.user.id);
              updatedAccessUsers.forEach((updatedAccessUser) => {
                if (!sharedIds.includes(updatedAccessUser.id)) {
                  const { id, access, firstName, lastName, username, profile } =
                    updatedAccessUser;
                  sharedArr.push({
                    id: filterSubFolder.id,
                    user: {
                      email: username,
                      id,
                      firstName,
                      lastName,
                      username,
                      profile,
                    },
                    userRole: {
                      id,
                      name: access,
                    },
                  });
                } else {
                  // update role--->
                  sharedArr.forEach((user) => {
                    if (user.user.id === updatedAccessUser.id) {
                      user.userRole.name = updatedAccessUser.access;
                    }
                  });
                }
              });

              filterSubFolder.sharedFolder = sharedArr;
            });
            subFolders[this.props.match.params.folderId].forEach((sub) => {
              const findFolder = filterSubFolders.find(
                (filterSubFolder) => filterSubFolder.id === sub.id
              );
              if (findFolder) {
                sub = findFolder;
              }
            });
            this.props.updateFolders({
              rootFolders: rootFolders,
              subFolders: subFolders,
            });
          }
        } else {
          // single folder and documents-->
          this.props.setShareFolders({}, 0);

          // updatesharedWith---->
          if (this.props.shareFolder.__typename === "DocumentType") {
            const documents = [...this.props.documents];
            documents.forEach((doc) => {
              if (doc.id === this.props.shareFolder.id) {
                const accessIds = this.state.accessUsers.map((user) => user.id);
                let sharedDocArr = [...doc.sharedDocument];
                sharedDocArr = sharedDocArr.filter((user) =>
                  accessIds.includes(user.user.id)
                );
                const sharedIds = sharedDocArr
                  .filter(
                    (user) =>
                      user.user.profile.role.name !== "IT Admin" &&
                      user.user.profile.role.name !== "Admin"
                  )
                  .map((user) => user.user.id);
                this.state.accessUsers.forEach((updatedAccessUser, index) => {
                  if (
                    index !== 0 &&
                    this.props.currentUserInfo.id !== updatedAccessUser.id
                  ) {
                    const {
                      id,
                      access,
                      firstName,
                      lastName,
                      username,
                      profile,
                    } = updatedAccessUser;
                    if (!sharedIds.includes(updatedAccessUser.id)) {
                      sharedDocArr.push({
                        id: doc.id,
                        user: {
                          email: username,
                          id,
                          firstName,
                          lastName,
                          username,
                          profile,
                        },
                        userRole: {
                          id,
                          name: access,
                        },
                      });
                    } else {
                      sharedDocArr.forEach((user) => {
                        if (user.user.id === updatedAccessUser.id) {
                          user.userRole.name = updatedAccessUser.access;
                        }
                      });
                    }
                  }
                });
                doc.sharedDocument = sharedDocArr;
              }
            });
            this.props.updateDocuments(this.props.documents);
          } else {
            let rootFolders = [...this.props.rootFolders];
            const subFolders = { ...this.props.subFolders };
            const subFolder = subFolders[this.props.match.params.folderId];
            if(subFolder) {
              if (this.props.shareFolder.parentFolder) {
                subFolders[this.props.match.params.folderId].forEach((sub) => {
                  if (sub.id === this.props.shareFolder.id) {
                    const accessIds = this.state.accessUsers.map(
                      (user) => user.id
                    );
                    let sharedArr = [...sub.sharedFolder];
                    sharedArr = sharedArr.filter((user) =>
                      accessIds.includes(user.user.id)
                    );
                    const sharedIds = sharedArr
                      .filter(
                        (user) =>
                          user.user.profile.role.name !== "IT Admin" &&
                          user.user.profile.role.name !== "Admin"
                      )
                      .map((user) => user.user.id);
                    this.state.accessUsers.forEach((updatedAccessUser, index) => {
                      if (
                        index !== 0 &&
                        this.props.currentUserInfo.id !== updatedAccessUser.id
                      ) {
                        const {
                          id,
                          access,
                          firstName,
                          lastName,
                          username,
                          profile,
                        } = updatedAccessUser;
                        if (!sharedIds.includes(updatedAccessUser.id)) {
                          sharedArr.push({
                            id: sub.id,
                            user: {
                              email: username,
                              id,
                              firstName,
                              lastName,
                              username,
                              profile,
                            },
                            userRole: {
                              id,
                              name: access,
                            },
                          });
                        } else {
                          sharedArr.forEach((user) => {
                            if (user.user.id === updatedAccessUser.id) {
                              user.userRole.name = updatedAccessUser.access;
                            }
                          });
                        }
                      }
                    });
                    sub.sharedFolder = sharedArr;
                  }
                });
              } else {
                subFolders[this.props.match.params.folderId].forEach((sub) => {
                  let sharedArr = [...sub.sharedFolder];
                  const sharedIds = sharedArr
                    .filter(
                      (user) =>
                        user.user.profile.role.name !== "IT Admin" &&
                        user.user.profile.role.name !== "Admin"
                    )
                    .map((user) => user.user.id);
                  this.state.accessUsers.forEach((updatedAccessUser, index) => {
                    if (
                      index !== 0 &&
                      this.props.currentUserInfo.id !== updatedAccessUser.id
                    ) {
                      const {
                        id,
                        access,
                        firstName,
                        lastName,
                        username,
                        profile,
                      } = updatedAccessUser;
                      if (!sharedIds.includes(updatedAccessUser.id)) {
                        sharedArr.push({
                          id: sub.id,
                          user: {
                            email: username,
                            id,
                            firstName,
                            lastName,
                            username,
                            profile,
                          },
                          userRole: {
                            id,
                            name: access,
                          },
                        });
                      }
                    }
                  });
                  sub.sharedFolder = sharedArr;
                });
                // Update root folder array when a root folder is shared
                rootFolders = [...this.props.rootFolders].map((rootFolder) => {
                  if (rootFolder.id === this.props.match.params.folderId) {

                    let sharedArr = [];
                    const sharedIds = sharedArr
                      .filter(
                        (user) =>
                          user.user.profile.role.name !== "IT Admin" &&
                          user.user.profile.role.name !== "Admin"
                      )
                      .map((user) => user.user.id);         
                      
                      this.state.accessUsers.forEach((updatedAccessUser, index) => {
                      if (
                        index !== 0 &&
                        this.props.currentUserInfo.id !== updatedAccessUser.id
                      ) {
                        const {
                          id,
                          access,
                          firstName,
                          lastName,
                          username,
                          profile,
                        } = updatedAccessUser;
                        if (!sharedIds.includes(updatedAccessUser.id)) {
                          sharedArr.push({
                            id: rootFolder.id,
                            user: {
                              email: username,
                              id,
                              firstName,
                              lastName,
                              username,
                              profile,
                            },
                            userRole: {
                              id,
                              name: access,
                            },
                          });
                        }
                      }
                    });

                    return {...rootFolder, sharedFolder: sharedArr}
                  } else {
                    return rootFolder
                  }
                });
              }
              this.props.updateFolders({
                rootFolders: rootFolders,
                subFolders: subFolders,
              });
            }
          }
        }
        this.props.setShare();
        const detail = "Success";
        const item =
          this.props.shareMultipleDocument
            ? "files"
            : "folders";
        const title = `All ${item} have been successfully shared`;
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message.includes("Guest user")
          ? "Please provide only Temporary User access to a Guest user!"
          : e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  render() {
    return (
      <div>
        <Modal
          size="lg"
          dialogClassName="share-modal"
          show={this.props.showShareModal}
          onHide={() => {
            this.setState({ defaultRole: "" });
            this.props.handleShareModal(this.props.totalCheck);
          }}
          centered
        >
          <Modal.Header>
            <h4 className="modal-title">Share</h4>
            <img
              className="close"
              src={CloseIcon}
              alt="closeIcon"
              onClick={() => {
                this.setState({ defaultRole: "" });
                this.props.handleShareModal(this.props.totalCheck);
              }}
            />
          </Modal.Header>
          <Modal.Body>
            <ShareWith
              colClass="col-md-12"
              type="sharePopup"
              defaultRole={this.state.defaultRole}
              accessUsers={this.state.accessUsers}
              filteredUsers={this.state.filteredUsers}
              folderAccess={this.state.folderAccess}
              setAccessUsers={this.setAccessUsers}
              setFilteredUsers={this.setFilteredUsers}
              shareFolder={this.props.shareFolder}
              checkedShareFolder={this.props.checkedShareFolder}
              totalCheck={this.props.totalCheck}
              currentUserInfo={this.props.currentUserInfo}
              subFolders={this.props.subFolders}
              multipleShare={this.multipleShare}
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => {
                this.setState({ defaultRole: "" });
                this.props.handleShareModal(this.props.totalCheck);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              onClick={this.shareHandler}
            >
              Share
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ShareModal;
